export default {
    inspectionsModal: {
        isOpen: false,
    },
};
